// AUTOGENERATED — do not edit. Source: schemas/modes/channel_strip.json. Run `bun run codegen/generate.ts` to regenerate.
import type { ModeSchema } from './types';

export interface ChannelStripParams {
  readonly pre_gain: number;
  readonly peak0_freq: number;
  readonly p02: number;
  readonly p03: number;
  readonly peak1_freq: number;
  readonly peak_q: number;
  readonly peak_gain: number;
  readonly in_lpf_cutoff: number;
  readonly in_hpf_cutoff: number;
  readonly p09: number;
  readonly comp_threshold: number;
  readonly comp_ratio: number;
  readonly comp_attack: number;
  readonly comp_release: number;
  readonly lowshelf_freq: number;
  readonly lowshelf_q: number;
  readonly lowshelf_gain: number;
  readonly highshelf_freq: number;
  readonly highshelf_q: number;
  readonly highshelf_gain: number;
  readonly p20: number;
  readonly p21: number;
  readonly p22: number;
  readonly post_gain: number;
}

export const ChannelStripSchema: ModeSchema = {
  mode_id: 'channel_strip',
  engine_id: 'channel_strip',
  ml: {
    input_channels: [
      'joy_x',
      'joy_y',
      'joy_z',
      'joy_w',
    ],
    input_size: 4,
    hidden_layers: [
      10,
      10,
      14,
    ],
    output_size: 24,
    default_spread: 0.6,
  },
  params: [
    {
      name: 'pre_gain',
      label: 'Pre Gain',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'square',
      group: 'gain',
    },
    {
      name: 'peak0_freq',
      label: 'Peak0 Freq',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'eq',
    },
    {
      name: 'p02',
      label: 'Param 02',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'general',
    },
    {
      name: 'p03',
      label: 'Param 03',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'general',
    },
    {
      name: 'peak1_freq',
      label: 'Peak1 Freq',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'eq',
    },
    {
      name: 'peak_q',
      label: 'Peak Q',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'linear',
      group: 'eq',
    },
    {
      name: 'peak_gain',
      label: 'Peak Gain',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'eq',
    },
    {
      name: 'in_lpf_cutoff',
      label: 'Input LPF',
      min: 0,
      max: 1,
      default: 0.7,
      curve: 'square',
      group: 'filters',
    },
    {
      name: 'in_hpf_cutoff',
      label: 'Input HPF',
      min: 0,
      max: 1,
      default: 0.2,
      curve: 'square',
      group: 'filters',
    },
    {
      name: 'p09',
      label: 'Param 09',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'general',
    },
    {
      name: 'comp_threshold',
      label: 'Comp Threshold',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'comp',
    },
    {
      name: 'comp_ratio',
      label: 'Comp Ratio',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'comp',
    },
    {
      name: 'comp_attack',
      label: 'Comp Attack',
      min: 0,
      max: 1,
      default: 0.1,
      curve: 'linear',
      group: 'comp',
    },
    {
      name: 'comp_release',
      label: 'Comp Release',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'comp',
    },
    {
      name: 'lowshelf_freq',
      label: 'Lowshelf Freq',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'eq',
    },
    {
      name: 'lowshelf_q',
      label: 'Lowshelf Q',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'linear',
      group: 'eq',
    },
    {
      name: 'lowshelf_gain',
      label: 'Lowshelf Gain',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'eq',
    },
    {
      name: 'highshelf_freq',
      label: 'Highshelf Freq',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'square',
      group: 'eq',
    },
    {
      name: 'highshelf_q',
      label: 'Highshelf Q',
      min: 0,
      max: 1,
      default: 0.3,
      curve: 'linear',
      group: 'eq',
    },
    {
      name: 'highshelf_gain',
      label: 'Highshelf Gain',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'eq',
    },
    {
      name: 'p20',
      label: 'Param 20',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'general',
    },
    {
      name: 'p21',
      label: 'Param 21',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'general',
    },
    {
      name: 'p22',
      label: 'Param 22',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'general',
    },
    {
      name: 'post_gain',
      label: 'Post Gain',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'square',
      group: 'gain',
    },
  ],
  voice_spaces: [
    'WannabeNeve66',
    'SSL 4K G-ist',
    'SSL 9K-inda',
    'MaleVox',
    'FemaleVox',
    'Neve 80',
  ],
  curve_overrides: [
    { voice_space: 1, param: 11, curve: 'square' },  // SSL 4K G-ist.comp_ratio
    { voice_space: 2, param: 11, curve: 'square' },  // SSL 9K-inda.comp_ratio
    { voice_space: 3, param: 13, curve: 'linear' },  // MaleVox.comp_release
    { voice_space: 4, param: 13, curve: 'linear' },  // FemaleVox.comp_release
    { voice_space: 5, param: 1, curve: 'linear' },  // Neve 80.peak0_freq
    { voice_space: 5, param: 4, curve: 'linear' },  // Neve 80.peak1_freq
    { voice_space: 5, param: 7, curve: 'linear' },  // Neve 80.in_lpf_cutoff
    { voice_space: 5, param: 8, curve: 'linear' },  // Neve 80.in_hpf_cutoff
    { voice_space: 5, param: 13, curve: 'linear' },  // Neve 80.comp_release
    { voice_space: 5, param: 14, curve: 'linear' },  // Neve 80.lowshelf_freq
    { voice_space: 5, param: 17, curve: 'linear' },  // Neve 80.highshelf_freq
  ],
  ui: {
    primary_input: 'joystick',
    show_voice_space_selector: true,
    show_synth_visualizer: false,
  },
};
